export default __webpack_public_path__ + "static/media/sync5.62ee6068.png";